import React, { useEffect } from 'react';
import './Login.scss';
import { Layout, AdBlock, AdImage } from '../../components';
import { Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { Link, useHistory } from 'react-router-dom';

const Login = () => {

    const history = useHistory();

    useEffect(() => {
        scroll.scrollToTop();
    }, [])


    return (
        <Layout background="#1f2024">

            <div className="login">
                <div className="login__container--link">
                    <Link className="login__Link" to="login/usuarios">¿Sos usuario?</Link>
                </div>
                <div className="login__container--link">
                    <Link className="login__Link" to="login/prestadores">¿Sos Prestador?</Link>
                </div>
            </div>
        </Layout>
    )
}

export default Login;
